import React from 'react';
import TextField from '@material-ui/core/TextField';
import Skeleton from '@material-ui/lab/Skeleton'; 

export default function TextFieldFullWidth({
  ...props
}) {

  if (!props.isLoading) {
    return (
      <TextField
          multiline = {props.multiline ? (true):(false)}
          maxRows = {props.maxRows || props.rows}
          minRows = {props.minRows || props.rows}
          id={props.id}
          label={props.label}
          style={{ margin: 8 }}
          placeholder={props.placeholder}
          helperText={props.helperText}
          type={props.type ? (props.type):("text")}
          fullWidth
          value={props.value ?? ''}
          onChange={props.onChange}
          margin="normal"
          disabled={props.disabled}
          InputLabelProps={{
            shrink: true,
          }}
      />
    );
  } else {
    return (
      <Skeleton 
        style={{ margin: 8 }} 
        variant="text"
        animation="wave"
        height={71}/>
    )
  }
}